import { NavLink, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { can, ROLE_AR } from "@/v2/lib/rbac";
import { Chip } from "@/v2/components/ui";
import {
  LayoutDashboard, BarChart3, Users, Swords, ScrollText, Settings, ShieldCheck, Activity,
} from "lucide-react";

const SECTIONS = [
  { to: "/admin", label: "مركز القيادة", icon: LayoutDashboard, perm: "view_admin", end: true },
  { to: "/admin/people", label: "الأفراد والإدارات", icon: Users, perm: "manage_users" },
  { to: "/admin/content", label: "استوديو المحتوى", icon: Swords, perm: "manage_content" },
  { to: "/admin/performance", label: "الأداء والقياس", icon: BarChart3, perms: ["view_reports", "manage_users", "manage_points"] },
  { to: "/admin/pulse", label: "نبض التعلّم", icon: Activity, perm: "manage_pulse" },
  { to: "/admin/audit", label: "سجل الإدارة", icon: ScrollText, perm: "view_audit" },
  { to: "/admin/settings", label: "إعدادات التقييم", icon: Settings, perm: "manage_settings" },
];

export default function AdminShell() {
  const { user } = useAuth();
  if (!can(user, "view_admin")) return <Navigate to="/dashboard" replace />;
  const items = SECTIONS.filter((s) => s.perms ? s.perms.some((perm) => can(user, perm)) : can(user, s.perm));

  return (
    <div className="space-y-6" data-testid="admin-control-center">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-2xl bg-[#91cab8]/15 text-[#91cab8] flex items-center justify-center">
            <ShieldCheck size={22} />
          </div>
          <div>
            <div className="text-lg font-extrabold">مركز التحكم الإداري</div>
            <div className="text-xs text-[#bcc8cf]">واجهة موحّدة لإدارة الأفراد والمحتوى والأداء</div>
          </div>
        </div>
        <Chip tone="gold" className="!py-1.5">{ROLE_AR[user?.role] || ""} — {user?.name}</Chip>
      </div>

      <nav className="flex lg:flex-wrap gap-2 overflow-x-auto lg:overflow-visible pb-1" data-testid="admin-nav">
        {items.map((s) => (
          <NavLink key={s.to} to={s.to} end={s.end} data-testid={`admin-nav-${s.to.split("/").pop()}`}
            className={({ isActive }) =>
              `shrink-0 inline-flex items-center gap-2 px-4 h-10 rounded-full text-xs sm:text-sm font-bold transition-all ${
                isActive
                  ? "bg-gradient-to-l from-[#e3c799] to-[#bb9661] text-[#25343f]"
                  : "text-[#bcc8cf] bg-white/5 border border-white/10 hover:text-white"
              }`}>
            <s.icon size={16} /> {s.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
